
import { UserContext } from './context/user-context'
import React from 'react'
import './App.css'
import { useTelegram } from "./utils/useTelegram";
// import Header from "./components/Header/Header";
import { Route, Routes } from 'react-router'
// import ProductList from "./components/ProductList/ProductList";
// import Form from "./components/Form/Form";
const UnauthenticatedApp = React.lazy(() => import('./unauthenticated-app'));
const AuthenticatedApp = React.lazy(() => import('./authenticated-app'));

function App() {
  const userContext = React.useContext(UserContext)
  const { onToggleButton, tg, user } = useTelegram();

    // React.useEffect(() => {
    //     tg.ready();
    // }, [])

  return (
    <React.Suspense fallback={<div style={{width:window.innerWidth, display:'flex', justifyContent:'center',alignItems:'center',width:'100%',height:'100%'}}><p style={{color:'var(--tg-theme-accent-text-color)'}}>Загрузка...</p></div>}>
      {userContext.isAuth ? <AuthenticatedApp /> : <UnauthenticatedApp />}
    </React.Suspense>
      // <div className="App">
      //     <p style={{color:'blue'}}>{JSON.stringify(user)}</p>
      //     {/* <p style={{color:'white'}}>{'Привет, '+user?.username+' 😁'}</p> */}
      //     {/* <Header /> */}
      //     <Routes>
      //         {/* <Route index element={<ProductList />}/> */}
      //         {/* <Route path={'form'} element={<Form />}/> */}
      //     </Routes>
      // </div>
  );
}

export default App;